export default __webpack_public_path__ + "static/internet-374d4bc1c1a9eb0c5546920a01b38d51.png";